// extracted by mini-css-extract-plugin
export default {"container":"Image_container__9UMcb","img":"Image_img__w9Bgm"};